export class cardCourse {
    courseName:string;
    teach_name?:string;
    startDate:number;    
    endDate:number; 
    status?:string;
    url: number; 
    icon:string;
  }